<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.row_action {
  cursor: pointer;
  &:hover {
    background-color: #F8FAFC;
  }
}

.row_action {
  cursor: pointer;
  &:hover {
    background-color: #EFF5FB;
  }
}

.is-incomplete, .is-incomplete .text-muted {
    //color: #FFFFFF ! important;
    //background-color: #D3E4F9;
}

</style>

<template>
    <div v-if="profile.waterPointId" class="row mt-1 mb-1"> 
        <div class="col-12">
            <WaterPointSelect ref="waterPointSelect" :waterPointId="profile.waterPointId" :disabled="true" :updateOnChange="irrigationList"></WaterPointSelect>
       </div>
    </div>
    
    <WaterPointWellAlert v-if="!alertDocumentationIntervall" :waterPointId="profile.waterPointId"></WaterPointWellAlert> 
   
    <div class="row align-items-center py-2 ">
        <div class="col">
            <!-- Page pre-title -->
            
            <div class="page-pretitle">
                Erfassen & Speichern
            </div>
            <h2 class="page-title">
                Ruhewasserstände
            </h2>
        </div>
        <!-- Page title actions -->
        <div v-show="!alertDocumentationIntervall && !this.loading" class="col-auto ms-auto d-print-none">
            <div class="btn-list">
                <a href="#" class="btn btn-info d-none d-sm-inline-block" @click="openAlterModal()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                Ruhewasserstand dokumentieren
                </a>
                <a href="#" class="btn btn-info d-sm-none btn-icon" @click="openAlterModal()" aria-label="Create new report">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </a>
            </div>
        </div>
    </div>
           
    <Alert type="info" :show="alertEmpty && !alertDocumentationIntervall">
        <template v-slot:title>Kein Ruhewasserstand dokumentiert</template>
        Zur Dokumentation eines neuen Ruhewasserstands klicken Sie bitte auf das blau hinterlegte PLUS
    </Alert>
    
    <Alert type="info" :show="alertNew" :timeout="30000">
        <template v-slot:title>Ruhewasserstand dokumentiert</template>
        Alle Informationen zum Ruhewasserstand und die weitere Option zur Korrektur erhalten Sie durch einen Klick auf die ensprechende Zeile der Liste.
    </Alert> 
    
    <Alert type="success" :show="alertRemove" :timeout="6000">
        <template v-slot:title>Ruhewasserstand korrigiert</template>
        Die Korrektur des Ruhewasserstand wurde gespeichert.
    </Alert>
    
    <LevelIntervalAlert v-model:isAlert="alertDocumentationIntervall" ></LevelIntervalAlert>
    
    <div v-show="loading" class="progress progress-sm mb-2">
        <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
    </div>
    <div v-show="irrigationList.length > 0" class="card_">
        <div class="table-responsive mt-2">
            <table class="table table-vcenter card-table">
                <thead>
                    <tr>
                        <th title="Datum der Messung">
                            Datum
                        </th>
                        <th title="Abstand zur Messmarke" class="text-end">
                            Abstand zur Messmarke
                        </th>
                        <th title="Grundwasserstand in Ruhe" class="text-end">
                            Grundwasserstand
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="irrigation in reverseList(irrigationList)" v-bind:key="irrigation.id" :class="{'is-incomplete':!isIrrigationCompleted(irrigation) }"
                        class="row_action" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Enable dark mode" @click="openAlterModal(irrigation)" >
                        <td title="Beginn der Maßnahme">
                            <small class="d-block text-muted text-truncate" v-text="formatDateTime(irrigation.datetime, 'DD.MM HH:mm')">
                            </small>
                        </td>
                        <td title="Abstand zur Messmarke in m" class="text-end">
                            <small class="d-block text-muted text-truncate">
                                {{ (irrigation.stillWaterLevel).toFixed(2).replace('.', ',') }} m
                            </small> 
                        </td>
                        <td title="Grundwasserstand in Ruhe in m" class="text-end">
                            <small class="d-block text-muted text-truncate">
                                {{ (waterPoint.gaugeMark - irrigation.stillWaterLevel).toFixed(2).replace('.', ',') }} m
                            </small> 
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <AlterModal ref="alterIrrigation" v-model:mode="alterMode" :profile="profile" :irrigation="irrigation" :irrigationList="irrigationList" v-on:submit="submitAlterModal" :key="modalKey"></AlterModal>
</template>

<script>
import * as dayjs from 'dayjs';
import axios from 'axios'; 

import AlterModal from '@/components/level/AlterModal.vue';
import LevelIntervalAlert from '@/components/level/LevelIntervalAlert.vue';
import Alert from '@/components/Alert.vue';
import WaterPointSelect from '@/components/waterpoint/WaterPointSelect.vue';
import WaterPointWellAlert from '@/components/waterpoint/WaterPointWellAlert.vue';

//import { default as utils, common } from "@/global";

export default {
    name: 'Level',
    components: {
        AlterModal,
        Alert,
        WaterPointSelect,
        WaterPointWellAlert,
        LevelIntervalAlert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        profile: {
            type: Object,
            default: undefined
        }
    },
    data: function () {
        return {
            irrigationList : [],
            waterPointId: null,
            irrigation: null,
            alterMode: 'new',
            loading: false,
            loadingProgress: null,
            alertNew: false,
            alertEmpty: false,
            alertRemove: false,
            alertDocumentationIntervall: false,
            modalKey: 0,
        }
    },
    computed: {
        waterPoint: function () {
            let waterPoint = this.state.actions.waterPoint.get(this.profile.waterPointId);
            return waterPoint ? waterPoint: {};
        },
        isWaterPointSelected: function () {
            return this.profile.waterPointId  !== null;
        },
        isWaterPointWell: function () {
            return this.waterPoint.typ === 'brunnen';
        }
    },
    methods: {
        openAlterModal: function (irrigation=null) { 
            this.alterMode = irrigation ? 'view': 'new';
             
            if (irrigation && !this.isIrrigationCompleted(irrigation)) {
                this.alterMode = 'complete';    
            }

            this.modalKey = this.modalKey + 1;
            this.irrigation = irrigation ? irrigation: {};
           
            this.$nextTick(function() { 
                this.$refs.alterIrrigation.openModal();
            });
        },
        submitAlterModal: function (irrigation) {
            let self = this;
            
            // Set new waterPointId for profile
            self.state.actions.profile.set({waterPointId: irrigation.waterpointId})
            
            self.alertNew = false;
            self.addData(irrigation, function () {
                self.alertNew = true;
                self.profile.waterPointId && self.$refs.waterPointSelect.update();
            });
            
        },
        submitRemoveModal: function (correction) {
            let self = this;
            
            self.alertRemove = false;
            self.removeData(correction, function () {
                self.alertRemove = true;
            });
        },
        reverseList: function (list) {
            return [].concat(list).reverse();
        },
        isIrrigationCompleted: function (irrigation) {
            return !(irrigation.countEnd === null);
        },
        formatDateTime: function (date, format) {
            return dayjs(date).format(format);
        },
        getCountStart: function (irrigation) {
            return irrigation.countStart;
        },
        getWaterWithdrawal: function (irrigation) {
            if (irrigation.countStart !== null && irrigation.countEnd !== null) {
                if (irrigation.countStart < irrigation.countEnd) {
                    return (irrigation.countEnd - irrigation.countStart);
                }
            }
            return null;
        },
        getIrrigationLevel: function (irrigation) {
            if (this.getWaterWithdrawal(irrigation) && this.profileArea) {
                return Math.ceil(
                    1000 * this.getWaterWithdrawal(irrigation) / this.profileArea
                );
            }
            
            return null;
        },
        getListMaxDateItem: function () {
            if (this.irrigationList.length == 0 ) {
                return null;
            }
                        
            return this.irrigationList.reduce( function (a, b) {
                return dayjs(a.datetime) > dayjs(b.datetime)  ? a : b;
            })
            
        },
        fetchData: function (callback) {
            let self = this;
            
            let query = {
                query: `
                    query ($waterPointId: Int!, $year: Int) {
                        waterPointLevels(waterpointId: $waterPointId, year: $year) {
                            id
                            profileId
                            waterpointId
                            refId
                            datetime
                            stillWaterLevel
                            normalWaterLevel
                            comment
                        },
                        loggedIn
                    }
                `,      
                variables: {
                    waterPointId : self.profile.waterPointId,
                    year: self.profile.year
                }           
            }
            
            let request = Object.assign({}, self.config.request,
            {
                data: query,
            });
            
            self.loading = true;
           
            axios(request).then( function (response) {
                let data = response.data.data;
            
                if ( data !== null ) {
                    
                    self.irrigationList = data.waterPointLevels.map( function (item) {
                        return item;
                    });
                    
                    self.state.actions.level.setList(self.irrigationList);
                    
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
                
            });
        },
        addData: function (irrigation, callback) {
        
            let self = this;
            
            const query = {
                query: `
                  mutation (
                    $profileId: Int!
                    $year: Int!
                    $waterpointId: Int!
                    $refId: Int
                    $datetime: DateTime
                    $stillWaterLevel: Float  
                    $normalWaterLevel: Float
                    $comment: String
                    ) {
                        alterWaterPointLevel(
                            profileId: $profileId
                            year: $year
                            waterpointId: $waterpointId
                            refId: $refId
                            datetime: $datetime
                            stillWaterLevel: $stillWaterLevel
                            normalWaterLevel: $normalWaterLevel
                            comment: $comment
                            ) {
                                success,
                                waterPointLevels {
                                    id
                                    profileId
                                    waterpointId
                                    refId
                                    datetime
                                    stillWaterLevel
                                    normalWaterLevel
                                    comment
                                }
                            }
                    }`
                ,
                variables: {
                    profileId: irrigation.profileId,
                    year: self.profile.year,
                    waterpointId: irrigation.waterpointId,
                    refId: irrigation.refId,
                    datetime: irrigation.datetime,
                    stillWaterLevel: irrigation.stillWaterLevel,
                    normalWaterLevel: irrigation.normalWaterLevel,
                    comment: irrigation.comment
                }
            };
            
            let request = Object.assign({}, self.config.request,
            {
                data: query,
                onUploadProgress: function (progressEvent) {
                    self.loadingProgress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                }
            
            });
                        
            self.loading = true;
            self.loadingProgress = null;

            axios(request).then( function (response) {
                let data = response.data.data;
                
                if ( data !== null ) {
                    self.irrigationList = data.alterWaterPointLevel.waterPointLevels.map( function (item) {
                        return item;
                    });
                    self.state.actions.level.setList(self.irrigationList);
                    
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
                
            });
            
        }
    },
    created: function () {
        
    },
    mounted: function () {
        var self = this;
        
        this.waterPointId = this.profile.waterPointId;
       
        this.$nextTick(function() { 
            
            if ( self.isWaterPointSelected ) {
                self.fetchData( function () {}); 
            } else {
                self.alertEmpty = true;
            }
            
        });        
    },
    watch: {
        loading: function (new_value, old_value) {
        
            // LOADING STARTING
            if ( new_value === true && old_value === false ) {
                this.alertEmpty = false;
            }
    
            // LOADING FINISHED
            if ( new_value === false && old_value === true ) {
                if (this.irrigationList.length == 0) {
                    this.alertEmpty = true;
                } else {
                    this.alertEmpty = false;
                }      
            }
        },
        '$route.query': {
            handler (new_value) {
                let action = new_value.action; 
                if (action && action === 'newlevel' ) {
                    this.openAlterModal();
                    this.$router.replace(this.$route.path);
                }
            },
            immediate: true           
        }
    }
}
</script>